import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';

export const ButtonVariant = {
  Primary: 'primary',
  Secondary: 'secondary',
  Icon: 'icon',
  Text: 'text',
  Inline: 'inline',
} as const;

export type ButtonVariantType =
  (typeof ButtonVariant)[keyof typeof ButtonVariant];

export const ButtonType = {
  Button: 'button',
  Submit: 'submit',
  Reset: 'reset',
} as const;

export type ButtonTypeType = (typeof ButtonType)[keyof typeof ButtonType];

export const ButtonSize = {
  MD: 'md',
  SM: 'sm',
} as const;

export type ButtonSizeType = (typeof ButtonSize)[keyof typeof ButtonSize];

export const ButtonColor = {
  Default: 'default',
  Secondary: 'secondary',
  Danger: 'danger',
  OnBrand: 'onBrand',
} as const;

export type ButtonColorType = (typeof ButtonColor)[keyof typeof ButtonColor];

export const ButtonIconPosition = {
  Start: 'start',
  End: 'end',
} as const;

export type ButtonIconPositionType =
  (typeof ButtonIconPosition)[keyof typeof ButtonIconPosition];

export type ButtonProps = {
  type?: ButtonTypeType;
  active?: boolean;
  disabled?: boolean;
  disabledReason?: string;
  loading?: boolean;
  size?: ButtonSizeType;
  color?: ButtonColorType;
  isGhost?: boolean;
  ariaLabel?: string;
  testId?: string;
  variant?: ButtonVariantType;
  iconName?: TUNDR_ICONS;
  iconPosition?: ButtonIconPositionType;
};
